import(/* webpackMode: "eager" */ "/vercel/path0/src/app/legal/layout.tsx");
